export function isMac() {
  return /Mac|iPod|iPhone|iPad/.test(navigator.platform);
}
